import { useContext } from 'react';
import {
  Box,
  alpha,
  lighten,
  IconButton,
  Tooltip,
  styled,
  useTheme,
  Typography
} from '@mui/material';
import MenuTwoToneIcon from '@mui/icons-material/MenuTwoTone';
import { SidebarContext } from 'src/contexts/SidebarContext';
import { AuthContext } from 'src/contexts/JWTAuthContext';

import HeaderUserbox from './Userbox';
import { FormattedMessage } from 'react-intl';
import DarkModeTwoToneIcon from '@mui/icons-material/DarkModeTwoTone';
import LightModeTwoToneIcon from '@mui/icons-material/LightModeTwoTone';
import { ThemeModeContext } from 'src/contexts/ThemeContext';
import { editAdmin } from 'src/api/adminRoutes';


function Header() {
  const { toggleSidebar, title, fixedExpanded } = useContext(SidebarContext);
  const theme = useTheme();
  const { mode, toggleTheme } = useContext(ThemeModeContext);
  const { uid } = useContext(AuthContext);

  const handleThemeToggle = () => {
    toggleTheme();
    // Persist the preference but don't block the UI while waiting
    editAdmin({ uid, theme: mode === 'dark' ? 'light' : 'dark' }).catch(() => {
      // Silently ignore errors
    });
  };


const HeaderWrapper = styled(Box)(
  ({ theme }) => `
        height: ${theme.header.height};
        color: ${theme.header.textColor};
        padding: ${theme.spacing(0, 2)};
        right: 0;
        z-index: 7;
        background-color: ${alpha(theme.header.background, 0.95)};
        backdrop-filter: blur(3px);
        position: fixed;
        justify-content: space-between;
        width: 100%;
        @media (min-width: ${theme.breakpoints.values.lg}px) {
          left: ${fixedExpanded ? theme.sidebar.width : '80px'};
          width: auto;
        }
`
);

  return (
    <HeaderWrapper
      display="flex"
      alignItems="center"
      sx={{
        boxShadow:
          theme.palette.mode === "dark"
            ? `0 1px 0 ${alpha(
                lighten(theme.colors.primary.main, 0.7),
                0.15
              )}, 0px 2px 8px -3px rgba(0, 0, 0, 0.2), 0px 5px 22px -4px rgba(0, 0, 0, .1)`
            : `0px 2px 8px -3px ${alpha(
                theme.colors.alpha.black[100],
                0.2
              )}, 0px 5px 22px -4px ${alpha(
                theme.colors.alpha.black[100],
                0.1
              )}`,
      }}
    >
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
        }}>
        <Tooltip
          arrow
          title={<FormattedMessage id='toggleMenu' />}
          sx={{
            display: { lg: "none", xs: "inline-block" },
          }}
        >
          <IconButton color="primary" onClick={toggleSidebar}>
              <MenuTwoToneIcon fontSize="small" />
          </IconButton>
        </Tooltip>
        <Typography variant="h3" component="h3" gutterBottom>
          {title}
        </Typography>
      </Box>
      <Box
        component="span"
        sx={{
          display: "flex",
          alignItems: "center",
          ml: 2,
          justifyContent: "flex-end",
        }}
      >
        <Tooltip arrow title={mode === 'dark' ? 'Light' : 'Dark'}>
          <IconButton color="primary" onClick={handleThemeToggle}>
            {mode === 'dark' ? (
              <LightModeTwoToneIcon fontSize="small" />
            ) : (
              <DarkModeTwoToneIcon fontSize="small" />
            )}
          </IconButton>
        </Tooltip>
        <HeaderUserbox />
      </Box>
    </HeaderWrapper>
  );
}

export default Header;
